<div class="card-4" >
    <div class="container">
        <mat-tab-group>
            <mat-tab [label]="('languages.opportunite.details.ContratActuel' | translate)">
              <!-- Just drop the ContratActuelComponent here -->
              <app-contract-actuel></app-contract-actuel>
            </mat-tab>
          
            <mat-tab [label]="('languages.opportunite.details.infoCompCampagne' | translate)">
              <app-information-complementaires></app-information-complementaires>
            </mat-tab>
          
            <mat-tab [label]="('languages.opportunite.details.infoCompLigne' | translate)">
              <app-information-specifiques></app-information-specifiques>
            </mat-tab>
          </mat-tab-group>
          
    </div>
</div>
